import { useFormikContext } from 'formik';
import { useCallback, useEffect, useRef } from 'react';

interface PriorAuthUnsavedChangesState {
    hasUserChanges: boolean;
    isSubmitting: boolean;
    onSave: () => Promise<boolean>;
    onDiscard: () => void;
}

interface PriorAuthUnsavedChangesSyncProps {
    isEditableQuestionSet: boolean;
    onUnsavedChangesStateChange: (state: PriorAuthUnsavedChangesState) => void;
}

export const PriorAuthUnsavedChangesSync = ({
    isEditableQuestionSet,
    onUnsavedChangesStateChange,
}: PriorAuthUnsavedChangesSyncProps) => {
    const formik = useFormikContext<{
        questionSetCompleted: boolean;
        attachment?: File[];
    }>();
    const formikRef = useRef(formik);
    // eslint-disable-next-line react-hooks/refs
    formikRef.current = formik;

    const handleSave = useCallback(async () => {
        const f = formikRef.current;
        await f.setFieldValue('questionSetCompleted', false);
        try {
            await f.submitForm();
            return true;
        } catch {
            return false;
        }
    }, []);
    const handleDiscard = useCallback(() => {
        formikRef.current.resetForm();
    }, []);

    useEffect(() => {
        onUnsavedChangesStateChange({
            hasUserChanges: isEditableQuestionSet && formik.dirty,
            isSubmitting: formik.isSubmitting,
            onSave: handleSave,
            onDiscard: handleDiscard,
        });
    }, [
        formik.dirty,
        formik.isSubmitting,
        handleDiscard,
        handleSave,
        isEditableQuestionSet,
        onUnsavedChangesStateChange,
    ]);

    return null;
};
